import cn from 'classnames';
import {useTranslation} from 'next-i18next';
import {Image} from '@/_application/core/components/ui/image';

interface Props {
    text?: string;
    className?: string;
    imageUrl?: string;
    size?: 'small' | 'large';
}

const NotFound: React.FC<Props> = ({className, text, imageUrl, size = 'large'}) => {
    const {t} = useTranslation('common');
    return (
        <div className={cn('flex h-full w-full flex-col items-center overflow-hidden', className)}>
            <div className="flex w-full items-center justify-center overflow-hidden bg-white px-2">
                <Image
                    src={imageUrl ?? 'https://cdn-v2.kidsplaza.vn/media/images/404.png'}
                    alt={text ? t(text) : t('text-no-result-found')}
                    className={cn('object-contain', {
                        'h-[400px] w-[400px]': size === 'large',
                        'h-[150px] md:h-[200px]': size === 'small',
                    })}
                    width={400}
                    height={400}
                />
            </div>
            {text && (
                <h3 className="my-7 w-full text-center text-base font-semibold text-body md:text-xl">{t(text)}</h3>
            )}
        </div>
    );
};

export default NotFound;
